import Container from "../common/Container"
import Layout from "../common/Layout"
import MarketingHeading from "../common/MarketingHeading"
import { ProductsList } from "../home/SolutionsForEveryScale"

const ProductPageTemplate = ({
  header,
  productId,
  pageContent,
  children,
}: {
  header: React.ReactNode
  productId:
    | "explorer"
    | "api"
    | "datashare"
    | "sheets"
    | "studio"
    | "mcp"
    | "research"
    | "integrations"
    | "data-partnerships"
    | "indexes"
  pageContent?: React.ReactNode
  children?: React.ReactNode
}) => {
  return (
    <Layout>
      {header}
      <Container className="mt-6">{children}</Container>
      {pageContent}
      <div className="bg-linear-to-b from-bg-default to-bg-surface">
        <Container className="pt-[50px] pb-[40px] md:pt-[100px] md:pb-[100px]">
          <div className="flex gap-2 items-center justify-center mb-10">
            <MarketingHeading level={2}>Our other products</MarketingHeading>
          </div>
          <ProductsList omittedProduct={productId} />
        </Container>
      </div>
    </Layout>
  )
}

export default ProductPageTemplate
